export default __webpack_public_path__ + "static/media/rob_moodie.6789b0e0.jpg";